import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/Poshmark-Community-Shares';

export default function Example() {
  return (
    <>
      <Head>
        <title>Easy Poshmark Strategy: What You Need To Know About Sharing</title>
        <meta
          name='description'
          content='In the Poshmark community, it matters to build your network among buyers and even fellow sellers matters. As a social e-commerce platform, they are all about creating high visibility. Whether you are selling or buying, it helps all kinds of users to achieve their goals. These take in the form of Posh parties, connecting with hosts, and even with a Poshmark ambassador.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/Poshmark-Community-Shares' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/Poshmark-Community-Shares' />
        <meta property='og:title' content='Easy Poshmark Strategy: What You Need To Know About Sharing' />
        <meta
          property='og:description'
          content='In the Poshmark community, it matters to build your network among buyers and even fellow sellers matters. As a social e-commerce platform, they are all about creating high visibility. Whether you are selling or buying, it helps all kinds of users to achieve their goals. These take in the form of Posh parties, connecting with hosts, and even with a Poshmark ambassador.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
